import React from "react";

import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const LocationItem = ({ location, onClick }) => {
  const theme = useTheme();

  const handleLocationSelected = () => {
    if (!onClick) return;
    onClick();
  };

  return (
    <Box
      sx={{
        boxShadow: theme.shadows[4],
        padding: "4px",
        borderRadius: "4px",
        cursor: onClick ? "pointer" : "default",
      }}
      onClick={handleLocationSelected}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography sx={{ fontSize: "12px", fontWeight: "bold" }}>
          {`${location.name} ${
            location.locationNumber ? `#${location.locationNumber}` : ""
          }`}
        </Typography>
        {location.territory ? (
          <Typography sx={{ fontSize: "12px", fontWeight: "bold" }}>
            {location.territory}
          </Typography>
        ) : null}
      </Box>
      <Box>
        <Typography
          sx={{ fontSize: "10px" }}
        >{`${location.streetAddress}, ${location.city}, ${location.province}, ${location.postal}`}</Typography>
      </Box>
    </Box>
  );
};

export default LocationItem;
